module.exports = __webpack_public_path__ + "img/crear-ov-logo.fd96ce8f.svg";